import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Heading from '@hubins/components/Heading';
import { __ } from 'localisation';

import { useMiddleman } from '@hubins/middleman';

const LoggedOut = ({ timer = 2000 }) => {
  const middleman = useMiddleman();
  const { logout } = useAuth();


  const [redirect, setRedirect] = useState(false);
  useEffect(() => {
    middleman.post(`/v1/fa/logout`, null);
    logout();
    const myTimer = setTimeout(() => {
      setRedirect(true);
    }, timer);
    return () => {
      clearTimeout(myTimer);
    };
  }, []);

  return (
    <main className="main main--center" id="MainContent" data-shiftonsidebaropen>
      <div className="center">
        <img src="/illustrations/login.svg" alt="A locked lock" className="illustration illustration--medium" />
        <Heading size="3">{__('logout_title')}</Heading>
        <p>{__('logout_description')}</p>
        {redirect && <Redirect to="/" />}
      </div>
    </main>
  );
};




export default LoggedOut;
